import Page from 'modules/app/components/Page';
import TopMenuForShop from 'modules/feed/components/Feed/TopMenuForShop/TopMenuForShop';
import ProductCategories from './ProductCategories';
import Products from './Products';
import ShoppingCart from './ShoppingCart';
import {useTypedSelector} from 'store/useTypedSelector';
import {useActions} from 'store/useActions';
import Brands from './Brands/Brands';
import Search from './Search/Search';
import {useState, useEffect} from 'react';
import SeachedProducts from './SeachedProducts';
import {useDebounce} from 'hooks/useDebounce';

import Stores from './Stores/Stores';

const Venues = () => {
    const {isOpenBasket} = useTypedSelector(state => state.postSlice);
    const {setIsOpenBasket, setIsSlideChange} = useActions();

    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText);

    useEffect(() => {
        setIsSlideChange(false);
    }, []);

    return (
        <Page activeLink="/shop">
            <TopMenuForShop onOpen={setIsOpenBasket}/>
            <Search searchText={searchText} setSearchText={setSearchText}/>
            {searchText ? (
                <SeachedProducts searchText={debouncedSearchText}/>
            ) : (
                <>
                    <ProductCategories/>
                    <Brands/>
                    <Stores/>
                    <Products/>
                </>
            )}
            <ShoppingCart open={isOpenBasket} setOpenShoppingCartMenu={setIsOpenBasket}/>
        </Page>
    );
};

export default Venues;
